<template>
    <div v-if="isCookieToastVisible && !isLoading" class="cookie-toast-wrap">
        <div class="wrapper">
            <div class="cookie-toast">
                <button @click="setOnlyTech()" class="close"><img src="/images/close-dark.svg" width="18" height="18" class="image" alt="Valsped" /></button>
                <div class="description">
                    <div class="title"><img src="/images/cookie.svg" class="icon" alt="Cookie" />{{ localizer.get("CookieToast.Common.CookiePolicy") }}</div>
                    <span v-html="localizer.get('CookieToast.Common.Description', routes.DataSecurity_CookiePolicy, localizer.get('CookieToast.Common.CookiePolicy'))"></span> 
                </div>
                <div class="links">
                    <div class="item action">
                        <button @click="setCookieToast()" class="button" data-border>{{ localizer.get("CookieToast.Common.AgreeAll") }}</button>
                    </div>
                    <div class="item tech">
                        <button @click="setOnlyTech()" class="button" data-border>{{ localizer.get("CookieToast.Common.OnlyTechnicians") }}</button>
                    </div>
                    <div class="item custom">
                        <button @click="setCustomize()" class="button" data-border>{{ localizer.get("CookieToast.Common.Customize") }}</button>
                    </div>
                </div>
                <div :class="['customize', !isCustomize ? 'hden' : '']">
                    <div class="list-item">
                        <div class="item">
                            <div class="info" data-full>
                                <div class="type">{{ localizer.get("CookieToast.Common.Technicians") }}</div>
                                ValspedGroup.it, Google Analytics
                            </div>
                        </div>
                    </div>
                    <div class="confirm">
                        <button @click="setCustomCookie()" class="button" data-border>{{ localizer.get("CookieToast.Common.SavePreferences") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

const store = useStore();
const localizer = Localizer;
const isLoading = ref(true);
const isCustomize = ref(false);
const isActivateStatistics = ref(false);
const isActivateProfiling = ref(false);
const customizeCookieValues = ref<string[]>(["tech"]);

const isCookieToastVisible = computed(() => store.getters["cookieToastStore/isCookieToastVisible"]);
const routes = (window as any).App.routes;

watch(isCookieToastVisible, async (newValue: boolean) => {
    isLoading.value = true;
    store.commit("cookieToastStore/setCookieToastVisible", newValue);
    isLoading.value = false;
});

if (!CookieHelper.isCookiePolicy()) {
    store.commit("cookieToastStore/setCookieToastVisible", true);
}
isLoading.value = false;

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;
    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        const index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;
    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        const index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}
</script>